import { intensityFactor, normalizedPower, tss } from '@/ride/metrics';
import { powerProfile } from './flatten';
import type { Step } from './model';

export interface WorkoutStats {
  durationSec: number;
  np: number;
  if: number;
  tss: number;
}

/** Estimated IF/TSS of a workout plan (free segments assumed at 60 % FTP). */
export function workoutStats(steps: Step[], ftp: number): WorkoutStats {
  const p = powerProfile(steps, ftp);
  const np = normalizedPower(p);
  return { durationSec: p.length, np, if: intensityFactor(np, ftp), tss: tss(p.length, np, ftp) };
}
